import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { UrlToBase64 } from "../models/shared/UrlToBase64Dto.model";
import { Employee } from "../models/profile/employee";
import { ChatGptRequestDto } from "../models/common/chatGptRequestDto";

@Injectable({
  providedIn: "root",
})
export class CommonService {
  private commonBaseURL = environment.baseUrl + "/Common";
  private chatGptBaseURL = environment.baseUrl + "/ChatGpt";

  constructor(private _http: HttpClient) {}

  ConvertUrlToBase64(payload: UrlToBase64): Observable<UrlToBase64> {
    return this._http.post<UrlToBase64>(
      this.commonBaseURL + "/ConvertUrlToBase64",
      payload
    );
  }

  getAllBrandingConsultant(): Observable<GenericResponseDto<Employee[]>> {
    return this._http.get<GenericResponseDto<Employee[]>>(
      `${this.commonBaseURL}/GetAllBrandingConsultant`
    );
  }

  getAllBrandingConsultantDashboardPoc(): Observable<
    GenericResponseDto<Employee[]>
  > {
    return this._http.get<GenericResponseDto<Employee[]>>(
      `${this.commonBaseURL}/GetAllBrandingConsultantDashboardPoc`
    );
  }

  getAllBacDashboardPoc(): Observable<GenericResponseDto<Employee[]>> {
    return this._http.get<GenericResponseDto<Employee[]>>(
      `${this.commonBaseURL}/GetAllBacDashboardPoc`
    );
  }

  getAllManagerEmployees(): Observable<GenericResponseDto<Employee[]>> {
    return this._http.get<GenericResponseDto<Employee[]>>(
      `${this.commonBaseURL}/GetAllManagerEmployees`
    );
  }

  getAllBrandingConsultantWithSameLocation(): Observable<
    GenericResponseDto<Employee[]>
  > {
    return this._http.get<GenericResponseDto<Employee[]>>(
      `${this.commonBaseURL}/GetAllBrandingConsultantWithSameLocation`
    );
  }

  getAllBacWithSameLocation(): Observable<GenericResponseDto<Employee[]>> {
    return this._http.get<GenericResponseDto<Employee[]>>(
      `${this.commonBaseURL}/GetAllBacWithSameLocation`
    );
  }

  postChatGPTRequest(
    payload: ChatGptRequestDto
  ): Observable<GenericResponseDto<string>> {
    return this._http.post<GenericResponseDto<string>>(
      this.chatGptBaseURL + "/ChatGptResponseGenerator",
      payload
    );
  }
}
